import { Attribute, Component, Inject } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  AportacionDIPoseedorControllerService,
  AportacionDiAcuerdosGestoresControllerService,
  PrefacturacionHistoricoControllerService,
  PrefacturacionRequestDTO,
  PrefacturacionAcuerdosGestoresRequestDTO,
  PrefacturacionHistoricoFilterDTO,
  FacturaSddrcaControllerService,
  PeriodoFacturacionControllerService,
   PeriodoFacturacionDTO,
  DiccionarioControllerService,
  DiccionarioElementoDTO
} from 'api-rest';
import { Combo, ComboService } from '../../../services/combo.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { map } from 'rxjs';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { ParseCurrencyPipe } from '../../../share/components/pipe/ParseCurrency.pipe';
import { PreInvoicingPreviewModalComponent } from './pre-invoicing-preview-modal/pre-invoicing-preview-modal.component';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'lib-pre-invoicing',
  templateUrl: './pre-invoicing.component.html',
  styleUrls: ['./pre-invoicing.component.scss'],
})
export class PreInvoicingComponent {

  modulos: Combo[] = [];

  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  flagSearch: boolean = false;
  totalSearch: number = 0;
  mostrarFiltros: boolean = true;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
 
  generateForm: FormGroup;

  defaultFilter: boolean = true;
  headArray: any = [
    {
      Head: 'Fecha ejecución',
      FieldName: 'fechaEjecucion',
      renderValue: (item: any) =>
        this.datePipe.transform(item.fechaEjecucion, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Módulo / Proceso',
      renderValue: (item: any) =>
      item.modulo + ' / ' + item.proceso,
    },
    {
      Head: 'Usuario',
      FieldName: 'usuarioEjecucion'
    },
    {
      Head: 'Prefacturas generadas',
      FieldName: 'numeroPrefacturasGeneradas',
    },
    {
      Head: 'Estado',
      FieldName: 'jobInfo',
      Attribute: 'status',
      renderValue: (item: any) =>
        {
          switch (item.jobInfo?.status) {
            case 'ERROR':
              return 'Error';
              break;
            case 'EN_EJECUCION':
              return 'En ejecución';
              break;
            case 'FINALIZADO':
              return 'Finalizado'
              break;

          }
          return '';
        },
    },
    {
      Head: 'Fecha finalización',
      FieldName: 'fechaFinalizacion',
      renderValue: (item: any) =>
        this.datePipe.transform(item.fechaFinalizacion, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Errores detectados',
      FieldName: 'erroresGenerados',
      Tooltip: true,
      Maxtext: 10,
    }
  ];
  gridArray: any[] = [];
 
  fechaHasta: Date = new Date();
  tiposPeriodoFacturacion: any[] = [];
  
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    private aportacionDIPoseedorService: AportacionDIPoseedorControllerService,
    private aportacionDiAcuerdosGestoresService: AportacionDiAcuerdosGestoresControllerService,
    private facturaSddrcaService: FacturaSddrcaControllerService,
    private prefacturacionHistoricoService: PrefacturacionHistoricoControllerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private snackBarSrv: SnackbarService,
    private comboService: ComboService,
    public spinnerSrv: SpinnerService,
    private datePipe: DatePipe,
    private parseCurrencyPipe: ParseCurrencyPipe,
    private periodoFacturacionControllerSrv: PeriodoFacturacionControllerService,
    private diccionarioControllerService: DiccionarioControllerService,
        @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService
  ) {
    this.generateForm = this.formBuilder.group({
      modulo: [{ value: null, disabled: false }, { validators: Validators.compose([Validators.required]) }],
      fechaHasta: [{ value: this.fechaHasta, disabled: false }, { validators: Validators.compose([Validators.required]) }],
      importeMinimo: [{ value: null, disabled: false }, { validators: Validators.compose([Validators.required]) }],
      importeMinimoDepositoIBC: [{ value: null, disabled: false }],
      importeMinimoDepositoPallet: [{ value: null, disabled: false }],
      periodoFacturacion: [ { value: null, disabled: false } ],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],

    });
  }

  ngOnInit(): void {
    this.modulos = this.comboService.getComboModulosPrefacturacion();
    this.comboPeridosFacturacion();
    this.comboOrden();
  }

  previsualizar(): void {
    if (this.generateForm.invalid) {
      this.generateForm.markAllAsTouched();
      return;
    }
    const modulo = this.generateForm.get('modulo')?.value.id;
    const periodoId = this.generateForm.get('periodoFacturacion')?.value;
    const periodoFacturacion = this.tiposPeriodoFacturacion.find(p => Number(p.id) === Number(periodoId));

    if (modulo == 'ACUERDO_INDIRECTO') {
      const filtroPrefacturacionGestores: PrefacturacionAcuerdosGestoresRequestDTO = {
        fechaHasta: moment(this.generateForm.get('fechaHasta')?.value).format('YYYY-MM-DD'),
        importeMinimo: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimo')?.value),
        periodoFacturacion: periodoFacturacion,
      };

      const dialogRefGestores = this.dialog.open(PreInvoicingPreviewModalComponent, {
        width: '1350px',
        maxWidth: '95%',
        maxHeight: '95vh',
        disableClose: true,
        data: { modulo, filtro: filtroPrefacturacionGestores },
      });
      dialogRefGestores.afterClosed().subscribe((idGestores: number[] | undefined) => {
        if (idGestores && idGestores.length > 0) {
          this.ejecutarGeneracion(idGestores);
        }
      });
      return;
    }

    let incluirSDDRCA = false;
    if (modulo == 'SDDR_ABIERTO_APORTACIONES_DIS') {
      incluirSDDRCA = true;
    }

    const filtroPrefacturacion: PrefacturacionRequestDTO = {
      fechaHasta: moment(this.generateForm.get('fechaHasta')?.value).format('YYYY-MM-DD'),
      importeMinimo: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimo')?.value),
      incluirSDDRCA: incluirSDDRCA,
      periodoFacturacion: periodoFacturacion,
    };

    const dialogRef = this.dialog.open(PreInvoicingPreviewModalComponent, {
      width: '1350px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: { modulo, filtro: filtroPrefacturacion },
    });
    dialogRef.afterClosed().subscribe((idPoseedores: number[] | undefined) => {
      if (idPoseedores && idPoseedores.length > 0) {
        this.ejecutarGeneracion(idPoseedores);
      }
    });

  }
  comboOrden() {
    this.diccionarioControllerService
      .listarElementos(['ORDEN_ADMIN_PREFACTURACION_BUSQUEDA'])
      .subscribe((res) => (this.orden = res['ORDEN_ADMIN_PREFACTURACION_BUSQUEDA']));
  }
  generarPrefactura(): void {
    if (this.generateForm.invalid) {
      this.generateForm.markAllAsTouched();
      return;
    }
    const modulo = this.generateForm.get('modulo')?.value.id;

    if (modulo == 'ACUERDO_INDIRECTO') {
      const periodoId = this.generateForm.get('periodoFacturacion')?.value;
      const periodoFacturacion = this.tiposPeriodoFacturacion.find(p => Number(p.id) === Number(periodoId));

      const filtroPrefacturacionGestores: PrefacturacionAcuerdosGestoresRequestDTO = {
        fechaHasta: moment(this.generateForm.get('fechaHasta')?.value).format('YYYY-MM-DD'),
        importeMinimo: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimo')?.value),
        periodoFacturacion: periodoFacturacion,
      };

      const dialogRefGestores = this.dialog.open(PreInvoicingPreviewModalComponent, {
        width: '1350px',
        maxWidth: '95%',
        maxHeight: '95vh',
        disableClose: true,
        data: { modulo, filtro: filtroPrefacturacionGestores },
      });
      dialogRefGestores.afterClosed().subscribe((idGestores: number[] | undefined) => {
        if (idGestores && idGestores.length > 0) {
          this.ejecutarGeneracion(idGestores);
        }
      });
      return;
    }

    let incluirSDDRCA = false;
    if (modulo == 'SDDR_ABIERTO_APORTACIONES_DIS') {
      incluirSDDRCA = true;
    }
    const periodoId = this.generateForm.get('periodoFacturacion')?.value;
    const periodoFacturacion = this.tiposPeriodoFacturacion.find(p => Number(p.id) === Number(periodoId));

    const filtroPrefacturacion: PrefacturacionRequestDTO = {
      fechaHasta: moment(this.generateForm.get('fechaHasta')?.value).format('YYYY-MM-DD'),
      importeMinimo: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimo')?.value),
      incluirSDDRCA: incluirSDDRCA,
      periodoFacturacion: periodoFacturacion,
    };

    const dialogRef = this.dialog.open(PreInvoicingPreviewModalComponent, {
      width: '1350px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: { modulo, filtro: filtroPrefacturacion },
    });
    dialogRef.afterClosed().subscribe((idPoseedores: number[] | undefined) => {
      if (idPoseedores && idPoseedores.length > 0) {
        this.ejecutarGeneracion(idPoseedores);
      }
    });
  }

  private ejecutarGeneracion(idPoseedores?: number[]): void {
    if(this.generateForm.get('modulo')?.value.id == 'POSEEDORES_APORTACIONES_DIS' || this.generateForm.get('modulo')?.value.id == 'SDDR_ABIERTO_APORTACIONES_DIS'){
      this.generarPrefacturaPosAportDIS(idPoseedores);
    }else if(this.generateForm.get('modulo')?.value.id == 'SDDR_ABIERTO_SOLICITUDES'){
      this.generarPrefacturaSDDRASolicitud(idPoseedores);
    }else if(this.generateForm.get('modulo')?.value.id == 'ACUERDO_INDIRECTO'){
      this.generarPrefacturaAcuerdoIndirecto(idPoseedores);
    }
  }

  generarPrefacturaPosAportDIS(idPoseedores?: number[]){
    this.spinnerSrv.loadingShow();
    let incluirSDDRCA = false;
    if(this.generateForm.get('modulo')?.value.id == 'SDDR_ABIERTO_APORTACIONES_DIS'){
      incluirSDDRCA = true;
    }
    const periodoId = this.generateForm.get('periodoFacturacion')?.value;
    const periodoFacturacion = this.tiposPeriodoFacturacion.find(p => Number(p.id) === Number(periodoId));

    const filtroPrefacturacion: PrefacturacionRequestDTO = {
      fechaHasta: moment( this.generateForm.get('fechaHasta')?.value).format('YYYY-MM-DD'),
      importeMinimo: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimo')?.value),
      incluirSDDRCA: incluirSDDRCA,
      periodoFacturacion: periodoFacturacion,
      idPoseedores: idPoseedores,
    };
    this.aportacionDIPoseedorService.procesoPrefacturacion(filtroPrefacturacion).subscribe({
      next: (response: any) => {
        this.spinnerSrv.loadingHide();
        if(response!.erroresGenerados.length > 0){
          this.snackBarSrv.showSnackBar(
            `Ha ocurrido un error al generar la prefacturación. ${response!.erroresGenerados[0]}`,
            'error'
          );
        }else{
          this.snackBarSrv.showSnackBar(
            'Se ha lanzado el proceso de prefacturación correctamente.',
            'success'
          );
          this.buscar();
        }
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        console.log(err);
      },
    });
  }

  generarPrefacturaSDDRASolicitud(idPoseedores?: number[]){
    this.spinnerSrv.loadingShow();

    const periodoId = this.generateForm.get('periodoFacturacion')?.value;
    const periodoFacturacion = this.tiposPeriodoFacturacion.find(p => Number(p.id) === Number(periodoId));

    const filtroPrefacturacion: any = {
      fechaHasta: moment( this.generateForm.get('fechaHasta')?.value).format('YYYY-MM-DD'),
      importeMinimo: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimo')?.value),
      importeMinimoDepositoIBC: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimoDepositoIBC')?.value),
      importeMinimoDepositoPallet: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimoDepositoPallet')?.value),
      periodoFacturacion: periodoFacturacion,
      idPoseedores: idPoseedores,
    };
    this.facturaSddrcaService.procesoPrefacturacion2(filtroPrefacturacion).subscribe({
      next: (response: any) => {
        this.spinnerSrv.loadingHide();
        if(response!.erroresGenerados.length > 0){
          this.snackBarSrv.showSnackBar(
            `Ha ocurrido un error al generar la prefacturación. ${response!.erroresGenerados[0]}`,
            'error'
          );
        }else{
          this.snackBarSrv.showSnackBar(
            'Se ha lanzado el proceso de prefacturación correctamente.',
            'success'
          );
          this.buscar();
        }
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        console.log(err);
      },
    });
  }

  generarPrefacturaAcuerdoIndirecto(idGestores?: number[]){
    this.spinnerSrv.loadingShow();

    const periodoId = this.generateForm.get('periodoFacturacion')?.value;
    const periodoFacturacion = this.tiposPeriodoFacturacion.find(p => Number(p.id) === Number(periodoId));

    const filtroPrefacturacion: PrefacturacionAcuerdosGestoresRequestDTO = {
      fechaHasta: moment( this.generateForm.get('fechaHasta')?.value).format('YYYY-MM-DD'),
      importeMinimo: this.parseCurrencyPipe.transform(this.generateForm.get('importeMinimo')?.value),
      periodoFacturacion: periodoFacturacion,
      idGestores: idGestores,
    };
    this.aportacionDiAcuerdosGestoresService.procesoPrefacturacion(filtroPrefacturacion).subscribe({
      next: (response: any) => {
        this.spinnerSrv.loadingHide();
        if(response!.erroresGenerados.length > 0){
          this.snackBarSrv.showSnackBar(
            `Ha ocurrido un error al generar la prefacturación. ${response!.erroresGenerados[0]}`,
            'error'
          );
        }else{
          this.snackBarSrv.showSnackBar(
            'Se ha lanzado el proceso de prefacturación correctamente.',
            'success'
          );
          this.buscar();
        }
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        console.log(err);
      },
    });
  }

  buscar(initPage:boolean = true){
    if(initPage){
      this.pageNumber = 0;
    }
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.prefacturacionHistoricoService.findAll1(backendFilter,{page: page, size: size, sort:['fechaEjecucion,desc']}, orden, tipoOrden)
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.flagSearch = data.datos?.length !== 0 ? true : false;
            this.gridArray = data.datos ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  private getBackendFilter() {
    let backendFilter: PrefacturacionHistoricoFilterDTO = {};

    if(this.generateForm.get('modulo')?.value?.id == 'POSEEDORES_APORTACIONES_DIS' || this.generateForm.get('modulo')?.value?.id == 'SDDR_ABIERTO_APORTACIONES_DIS'){
      backendFilter = {
        modulo: PrefacturacionHistoricoFilterDTO.ModuloEnum.Poseedores,
        proceso: PrefacturacionHistoricoFilterDTO.ProcesoEnum.AportacionesDis
      };
    }else if(this.generateForm.get('modulo')?.value?.id == 'SDDR_ABIERTO_SOLICITUDES'){
      backendFilter = {
        modulo: PrefacturacionHistoricoFilterDTO.ModuloEnum.Sddrca,
        //proceso: PrefacturacionHistoricoFilterDTO.ProcesoEnum.SolicitudReutilizacion
      };

    }else if(this.generateForm.get('modulo')?.value?.id == 'ACUERDO_INDIRECTO'){
      backendFilter = {
        modulo: PrefacturacionHistoricoFilterDTO.ModuloEnum.AcuerdosGestores,
      };
    }
    
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.generateForm.get('orden')?.value;
    const tipoOrden = this.generateForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }



  limpiar(): void {
    this.generateForm.reset({
      fechaHasta: this.fechaHasta,
    });
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.generateForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => v !== filtro.value);
        this.generateForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.generateForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 1;
    //this.buscar(false);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const modulo = this.generateForm.get('modulo')?.value;
    if (modulo) {
      filtros.push({ label: `${modulo?.name ?? modulo?.id ?? String(modulo)}`, campo: 'modulo' });
    }

    const fechaHasta = this.generateForm.get('fechaHasta')?.value;
    if (fechaHasta) {
      const fecha = this.datePipe.transform(fechaHasta, 'dd/MM/yyyy') ?? fechaHasta;
      filtros.push({ label: `${fecha}`, campo: 'fechaHasta' });
    }

    const importeMinimo = this.generateForm.get('importeMinimo')?.value;
    if (importeMinimo !== null && importeMinimo !== undefined && importeMinimo !== '') {
      filtros.push({ label: `${importeMinimo}`, campo: 'importeMinimo' });
    }

    const importeMinimoDepositoIBC = this.generateForm.get('importeMinimoDepositoIBC')?.value;
    if (importeMinimoDepositoIBC !== null && importeMinimoDepositoIBC !== undefined && importeMinimoDepositoIBC !== '') {
      filtros.push({ label: `${importeMinimoDepositoIBC}`, campo: 'importeMinimoDepositoIBC' });
    }

    const importeMinimoDepositoPallet = this.generateForm.get('importeMinimoDepositoPallet')?.value;
    if (importeMinimoDepositoPallet !== null && importeMinimoDepositoPallet !== undefined && importeMinimoDepositoPallet !== '') {
      filtros.push({ label: `${importeMinimoDepositoPallet}`, campo: 'importeMinimoDepositoPallet' });
    }

const ordenes = this.generateForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.generateForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.generateForm.controls[controlName].hasError(errorName) &&
      this.generateForm.controls[controlName].touched
    );
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.buscar(false);
    }
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscar(false);
  }

  tiposPeriodoFacturacionSel(event: any) {
    this.generateForm.get('periodoFacturacion')?.setValue(event);
  }

  comboPeridosFacturacion() {
    this.periodoFacturacionControllerSrv.findAll7().subscribe({
      next: (data: Array<PeriodoFacturacionDTO>) => {
        this.tiposPeriodoFacturacion = data || [];
        // Si el combo tarda en cargar, reaplicamos la selección con los datos del poseedor ya recibidos
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    }
}
